import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bg" style={{ backgroundImage: "url('/Footer.png')" }} />
      <div className="footer-script">Caroline &amp; Michael</div>
      <div className="footer-date">October 30, 2026 · Naples, Florida</div>
    </footer>
  );
}
